(function($) {
    $(document).ready(function() {
        // if($("[js-tabs-parent]").length){
        //     $("[js-tabs-parent]").each(function () {
        //         var tabItem=$(this).find("[js-tabs-item]");
        //         var tabContent=$(this).find("[js-tabs-content]");
        //         if(tabItem.length){
        //             tabItem.click(function (e) {
        //                 e.preventDefault();
        //                 $('.pagination ul').remove();
        //
        //                 tabItem.removeClass("active");
        //                 $(this).addClass("active");
        //                 var contentRef=$(this).attr("tab-ref");
        //                 tabContent.each(function () {
        //                    if($(this).attr("tab-ref")==contentRef){
        //                        tabContent.removeClass("active");
        //                        $(this).addClass("active");
        //                    }
        //                 });
        //                 if($('body').hasClass('device')){
        //                     $(".newsroom__tab-list").hide();
        //
        //                     $(".about-brands__tabs-list").hide();
        //                     $(".pseudo-option a").text($(this).text());
        //                 }
        //                 // Appel du plugin
        //                 $('.pagination').pagination({
        //                     itemsToPaginate: ".news-item",
        //                     activeClass: 'active'
        //                 });
        //                 $( ".pagination li:first-child" ).trigger( "click" );
        //             });
        //         }
        //     });
        // }
        if($('body').hasClass('device')){
            $(".pseudo-option").click(function () {
                $(this).next('ul').show();
            });
        }
    });
})(jQuery);
